/**
 * WebSocket 统一管理服务
 * 支持设备实时数据和告警实时数据两个 WebSocket 连接
 */

class WebSocketService {
  constructor() {
    this.deviceWs = null
    this.warnWs = null
    this.deviceCallbacks = []
    this.warnCallbacks = []
    this.deviceHeartbeatTimer = null
    this.warnHeartbeatTimer = null
    this.deviceReconnectTimer = null
    this.warnReconnectTimer = null
    this.isDeviceManualClose = false
    this.isWarnManualClose = false
    this.deviceToken = ''
    this.warnToken = ''
  }

  /**
   * 获取 token
   */
  getToken() {
    return localStorage.getItem('token') || sessionStorage.getItem('token') || ''
  }

  /**
   * 初始化设备实时数据 WebSocket
   * @param {Function} callback 接收消息的回调
   */
  initDeviceWs(callback) {
    if (callback && this.deviceCallbacks.indexOf(callback) === -1) {
      this.deviceCallbacks.push(callback)
    }
    if (this.deviceWs && (this.deviceWs.readyState === WebSocket.OPEN || this.deviceWs.readyState === WebSocket.CONNECTING)) {
      console.log('[WebSocket] 设备数据连接已存在/正在连接')
      return
    }
    const token = this.getToken()
    this.deviceToken = token
    const wsUrl = `ws://157.122.13.48:8088/iot-api/deviceDataWs/604496467850838016/three?token=${token}`
    try {
      this.deviceWs = new WebSocket(wsUrl)
      this.isDeviceManualClose = false

      this.deviceWs.onopen = () => {
        console.log('[WebSocket] ✅ 设备数据连接已建立')
        this.startDeviceHeartbeat()
      }

      this.deviceWs.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data)
          // console.log('[WebSocket] 📨 设备数据:', data)
          this.deviceCallbacks.forEach(cb => {
            try { cb(data) } catch (e) { console.error('设备回调失败:', e) }
          })
        } catch (e) {
          console.error('[WebSocket] 解析设备数据失败:', e, event.data)
        }
      }

      this.deviceWs.onclose = (event) => {
        console.log('[WebSocket] ❌ 设备数据连接关闭:', event.code, event.reason)
        if (this.deviceHeartbeatTimer) {
          clearInterval(this.deviceHeartbeatTimer)
          this.deviceHeartbeatTimer = null
        }
        if (!this.isDeviceManualClose) {
          this.deviceReconnectTimer = setTimeout(() => {
            console.log('[WebSocket] 🔄 重连设备数据...')
            this.initDeviceWs(null)
          }, 3000)
        }
      }

      this.deviceWs.onerror = (error) => {
        console.error('[WebSocket] ⚠️ 设备数据错误:', error)
      }
    } catch (e) {
      console.error('[WebSocket] 初始化设备数据失败:', e)
    }
  }

  /**
   * 初始化告警实时数据 WebSocket
   * @param {Function} callback 接收消息的回调
   */
  initWarnWs(callback) {
    if (callback && this.warnCallbacks.indexOf(callback) === -1) {
      this.warnCallbacks.push(callback)
    }
    if (this.warnWs && (this.warnWs.readyState === WebSocket.OPEN || this.warnWs.readyState === WebSocket.CONNECTING)) {
      console.log('[WebSocket] 告警数据连接已存在/正在连接')
      return
    }
    const token = this.getToken()
    this.warnToken = token
    const wsUrl = `ws://157.122.13.48:8088/iot-api/warnWs/604469234560770048/three?token=${token}`
    try {
      this.warnWs = new WebSocket(wsUrl)
      this.isWarnManualClose = false

      this.warnWs.onopen = () => {
        console.log('[WebSocket] ✅ 告警数据连接已建立')
        this.startWarnHeartbeat()
      }

      this.warnWs.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data)
          console.log('[WebSocket] 📨 告警数据:', data)
          this.warnCallbacks.forEach(cb => {
            try { cb(data) } catch (e) { console.error('告警回调失败:', e) }
          })
        } catch (e) {
          console.error('[WebSocket] 解析告警数据失败:', e, event.data)
        }
      }

      this.warnWs.onclose = (event) => {
        console.log('[WebSocket] ❌ 告警数据连接关闭:', event.code, event.reason)
        if (this.warnHeartbeatTimer) {
          clearInterval(this.warnHeartbeatTimer)
          this.warnHeartbeatTimer = null
        }
        if (!this.isWarnManualClose) {
          this.warnReconnectTimer = setTimeout(() => {
            console.log('[WebSocket] 🔄 重连告警数据...')
            this.initWarnWs(null)
          }, 3000)
        }
      }

      this.warnWs.onerror = (error) => {
        console.error('[WebSocket] ⚠️ 告警数据错误:', error)
      }
    } catch (e) {
      console.error('[WebSocket] 初始化告警数据失败:', e)
    }
  }

  startDeviceHeartbeat() {
    if (this.deviceHeartbeatTimer) clearInterval(this.deviceHeartbeatTimer)
    this.deviceHeartbeatTimer = setInterval(() => {
      if (this.deviceWs && this.deviceWs.readyState === WebSocket.OPEN) {
        this.deviceWs.send(JSON.stringify({ type: 'HEARTBEAT', timestamp: Date.now() }))
      }
    }, 30000)
  }

  startWarnHeartbeat() {
    if (this.warnHeartbeatTimer) clearInterval(this.warnHeartbeatTimer)
    this.warnHeartbeatTimer = setInterval(() => {
      if (this.warnWs && this.warnWs.readyState === WebSocket.OPEN) {
        this.warnWs.send(JSON.stringify({ type: 'HEARTBEAT', timestamp: Date.now() }))
      }
    }, 30000)
  }

  unsubscribeDevice(callback) {
    const idx = this.deviceCallbacks.indexOf(callback)
    if (idx > -1) this.deviceCallbacks.splice(idx, 1)
  }

  unsubscribeWarn(callback) {
    const idx = this.warnCallbacks.indexOf(callback)
    if (idx > -1) this.warnCallbacks.splice(idx, 1)
  }

  closeDevice() {
    this.isDeviceManualClose = true
    if (this.deviceHeartbeatTimer) { clearInterval(this.deviceHeartbeatTimer); this.deviceHeartbeatTimer = null }
    if (this.deviceReconnectTimer) { clearTimeout(this.deviceReconnectTimer); this.deviceReconnectTimer = null }
    if (this.deviceWs) { this.deviceWs.close(1000, '手动关闭'); this.deviceWs = null }
    this.deviceCallbacks = []
  }

  closeWarn() {
    this.isWarnManualClose = true
    if (this.warnHeartbeatTimer) { clearInterval(this.warnHeartbeatTimer); this.warnHeartbeatTimer = null }
    if (this.warnReconnectTimer) { clearTimeout(this.warnReconnectTimer); this.warnReconnectTimer = null }
    if (this.warnWs) { this.warnWs.close(1000, '手动关闭'); this.warnWs = null }
    this.warnCallbacks = []
  }

  closeAll() {
    this.closeDevice()
    this.closeWarn()
  }
}

export default new WebSocketService()
